module.exports = __webpack_public_path__ + "static/media/img_ota.9b8b823c.jpg";